import Vue from "vue";

const $ = window.jQuery;
const $window = window.$window || $(window);
export function GetActiveJobs() {
    $(document).ready(function () {
        const activeJobsSection = $('#active_jobs_section')
        if (!activeJobsSection) return false
        const url = activeJobsSection.data('jobsurl')
        if (!url) return false
        const activeJobSection = new Vue({
            el: `#active_jobs_section`,
            data() {
                return {
                    loading: true,
                }
            },
            mounted() {
                const $that = this
                $.ajax({
                    method: 'POST',
                    url: ajax_object.ajaxurl,
                    data: {
                        action: 'getTalentifyJoblist',
                        nonce: ajax_object.nonce,
                        data: {url: url}
                    },
                    success: function (data) {
                        if (!data) return false
                        const parser = new DOMParser();
                        let wrapper = $('#active_jobs_section__wrapper')
                        const parsedHtml = parser.parseFromString(data, "text/html")
                        let aTags = parsedHtml.getElementsByTagName("a")
                        let pTag = `<p class="text-p mb-6">Ukoliko ste zainteresirani i želite postati dio našeg tima, pošaljite nam svoj životopis putem linka za prijavu unutar oglasa.</p>`
                        let item = '<article class="col-span-4 p-10 bg-white border border-phoenix-gray-800"> </article>'
                        if (aTags && Array.from(aTags).length) {
                            Array.from(aTags).forEach((el) => {
                                $(el).find('.name').after(pTag)
                                let href = $(el).attr('href')
                                item = `<article class="singleJob col-span-12 md:col-span-6 lg:col-span-4 bg-white border border-phoenix-gray-800">
                                <div class="p-10">                             
                                    <div class="mb-6">
                                         ${new XMLSerializer().serializeToString(el)}                                   
                                    </div>
                                    <div class="btn-wrap">
                                     <a href="${href}" target="_blank" class="btn">Prijavi se na oglas</a>
                                    </div>
                                </div>
                            </article>`

                                $(wrapper).append(item)
                            })
                        }
                        $that.loading = false
                    }
                })
            }
        })
    });
}
GetActiveJobs()
